import { Avatar, Box, IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useState, useEffect } from "react";
import ProfilePopup from "../widgets/ProfilePopup";
import Alert from "../widgets/AlertModal";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import { host } from "../constant/backendpath";
import { useLoader } from "../context/LoaderContext";

const InfoRow = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 2,
      borderBottom: "1px solid #eee",
      pb: 1,
    }}
  >
    <Typography
      variant="body1"
      sx={{ fontWeight: "bold", color: "#1976d2", width: "40%" }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={{ color: "#555", width: "60%", textAlign: "right" }}
    >
      {value || "-"}
    </Typography>
  </Box>
);

const Profilepage = ({
  chance,
  setChance,
  updateProfile,
  profileDetails,
  setProfileDetails,
  total,
}) => {
  // const [userName,setUserName] = useState('')
  const isSmall = useMediaQuery("(max-width:733px)");
  const { setLoading } = useLoader();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("info");

  useEffect(() => {
    fetchProfile();
  }, []);

  async function fetchProfile() {
    setLoading(true);
    try {
      const res = await axios.get(`${host}profile`, { withCredentials: true });
      // console.log('==== /profile GET response ====', res.data);
      if (res.status === 200) {
        const { details } = res.data;
        // console.log('Extracted details:', details);
        // console.log('Profile fields:', { name: details?.name, dept: details?.dept, reg_no: details?.reg_no, year: details?.year, number: details?.number });
        setProfileDetails(details);
        // Check if required profile fields are incomplete
        const requiredFields = ['name', 'dept', 'reg_no', 'year', 'number'];
        const isIncomplete = requiredFields.some(
          (field) => details[field] === null || details[field] === undefined || details[field] === ""
        );
        // console.log('isIncomplete:', isIncomplete, 'Setting chance to:', isIncomplete);
        setChance(isIncomplete);
      }
    } catch (err) {
      // console.log(err);
      setAlertMessage('Fetch unsuccessful. Please try again.');
      setAlertType('error');
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: "#F9FBFA",
        py: 4,
        px: { xs: 3, md: 6 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Alert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        type={alertType}
      />
      {chance && (
        <ProfilePopup
          profileDetails={profileDetails}
          setProfileDetails={setProfileDetails}
          setChance={setChance}
          updateProfile={updateProfile}
        />
      )}

      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", color: "#1976d2", mb: 4 }}
      >
        Profile
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: isSmall ? "column" : "row",
          alignItems: isSmall ? "center" : "flex-start",
          justifyContent: "center",
          gap: 4,
          width: "100%",
          mb: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: isSmall ? "100%" : "30%",
          }}
        >
          <Avatar
            sx={{
              width: 150,
              height: 150,
              mb: 2,
              borderRadius: "50%",
              boxShadow: 3,
            }}
          />
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                mr: 1,
              }}
            >
              {profileDetails.name || "-"}
            </Typography>
            <IconButton
              color="primary"
              size="small"
              onClick={() => setChance(true)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            boxShadow: 3,
            p: 4,
            width: isSmall ? "90%" : "60%",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              mb: 2,
              color: "#1976d2",
              textAlign: "center",
            }}
          >
            Personal Information
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <InfoRow label="Name" value={profileDetails.name} />
            <InfoRow label="Department" value={profileDetails.dept} />
            <InfoRow label="Register No" value={profileDetails.reg_no} />
            <InfoRow label="Year" value={profileDetails.year} />
            <InfoRow label="Phone" value={profileDetails.number} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Profilepage;
